import type { NotificationBroadcastProjectAssignPayload } from "../notification-broadcast.type";

import { NOTIFICATION_BROADCAST_TYPE } from "../notification-broadcast.enum";
import {
  isNotificationBroadcastNamedModel,
  isValidNotificationBroadcastBase,
} from "../notification-broadcast.helper";

export const isNotificationBroadcastProjectAssignPayload = (
  payload: unknown
): payload is NotificationBroadcastProjectAssignPayload =>
  isValidNotificationBroadcastBase(payload) &&
  payload.event_type === NOTIFICATION_BROADCAST_TYPE.PROJECT_ASSIGN &&
  "projects" in payload &&
  Array.isArray(payload.projects) &&
  payload.projects.length > 0 &&
  payload.projects.every(isNotificationBroadcastNamedModel) &&
  "user" in payload &&
  isNotificationBroadcastNamedModel(payload.user);
